import CommentType from '@/constants/comments/CommentType'
const {
  TaskGeneralComment,
  DisputeFollowUpCandidateModified,
  DisputeFollowUpCandidateStatedDidNotHappen,
  DisputeFollowUpClientModified,
  DisputeFollowUpClientStatedDidNotHappen,
  DisputeFollowUpTimesheetConflict,
} = CommentType

export default [
  TaskGeneralComment,
  DisputeFollowUpCandidateModified,
  DisputeFollowUpCandidateStatedDidNotHappen,
  DisputeFollowUpClientModified,
  DisputeFollowUpClientStatedDidNotHappen,
  DisputeFollowUpTimesheetConflict,
]
